module.exports = __webpack_public_path__ + "img/loader.38c0dd74.svg";